(() => {
  const root = document.documentElement;
  const setBarHeight = (h) => root.style.setProperty("--promo-bar-height", `${h}px`);
  const clearBarHeight = () => root.style.removeProperty("--promo-bar-height");

  const pad = (n) => (n < 10 ? "0" + n : "" + n);

  // Per-message countdown. Ported from the Hotel Collection announcement bar:
  // with a target date it counts down to it; with "reset daily" it counts down
  // to the next midnight until the target date is reached; with no target it is
  // always a rolling countdown to midnight.
  const startCountdown = (el) => {
    const targetStr = el.dataset.target || "";
    const resetDaily = el.dataset.resetDaily === "true";

    const render = (h, m, s) => {
      el.innerHTML = `<span>${pad(h)}</span> : <span>${pad(m)}</span> : <span>${pad(s)}</span>`;
    };
    const ended = () => render(0, 0, 0);

    const parse = (str) => {
      const [datePart, timePart] = str.split(" ");
      const [year, month, day] = datePart ? datePart.split("-").map(Number) : [];
      const [hour, minute] = timePart ? timePart.split(":").map(Number) : [0, 0];
      return new Date(year, month - 1, day, hour || 0, minute || 0);
    };

    const tick = () => {
      const now = new Date();
      let targetDate;

      if (targetStr && resetDaily) {
        const target = parse(targetStr);
        if (now >= target) return ended();
        targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
        if (now.toDateString() === target.toDateString()) targetDate = target;
      } else if (targetStr && !resetDaily) {
        targetDate = parse(targetStr);
        if (now > targetDate) return ended();
      } else {
        targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      }

      let diff = (targetDate.getTime() - now.getTime()) / 1000;
      const hrs = Math.floor(diff / 3600);
      diff -= hrs * 3600;
      const mins = Math.floor(diff / 60);
      const secs = Math.floor(diff - mins * 60);
      render(hrs, mins, secs);
    };

    tick();
    setInterval(tick, 1000);
  };

  const init = () => {
    const bar = document.querySelector(".announcement-bar:not([data-init])");
    if (!bar) return;
    bar.dataset.init = "true";

    const section = bar.closest(".announcement-bar-section");
    if (!section) return;

    // Always place the bar above the fixed header, regardless of section order.
    if (section !== document.body.firstElementChild) {
      document.body.insertAdjacentElement("afterbegin", section);
    }

    // Fixed reveal: the bar is visible by default (painted at load) and only
    // hidden while the page is scrolled away from the top. Adding .is-hidden slides
    // it off-screen and clears --promo-bar-height so the fixed header docks to the
    // top; scrolling back to the top removes it and restores the offset so the header
    // docks below the bar.
    const menu = document.querySelector(".main-menu");
    const syncByScroll = () => {
      const atTop = window.scrollY <= 0;
      section.classList.toggle("is-hidden", !atTop);
      if (menu) menu.classList.toggle("is-topbar-hidden", !atTop);
      if (atTop) setBarHeight(section.offsetHeight);
      else clearBarHeight();
    };

    window.addEventListener("scroll", syncByScroll, { passive: true });

    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(() => {
        if (window.scrollY <= 0) setBarHeight(section.offsetHeight);
      }).observe(section);
    }

    // Apply the initial state without animating on load: snap both the bar and the
    // fixed header (which transitions `top` off .is-topbar-hidden) to their initial
    // positions so the header doesn't slide down through the bar on first paint.
    section.style.transition = "none";
    if (menu) menu.style.transition = "none";
    syncByScroll();
    requestAnimationFrame(() => {
      section.style.transition = "";
      if (menu) menu.style.transition = "";
    });

    // Rotate messages (autoplay).
    const items = Array.from(bar.querySelectorAll(".announcement-bar__item"));
    if (items.length > 1) {
      const speed = (parseFloat(bar.dataset.autoplay) || 4) * 1000;
      let idx = 0;
      setInterval(() => {
        items[idx].classList.remove("is-active");
        idx = (idx + 1) % items.length;
        items[idx].classList.add("is-active");
      }, speed);
    }

    bar.querySelectorAll(".announcement-bar__timer").forEach(startCountdown);
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
